import axios from "axios";
import consts from "../consts";
import { setErroAPI, setError, setSuccess } from "../common/toast/toast";
import { initialize } from "redux-form";
import confirmDialog from "../common/dialog/confirmDialog";
import { transformarCompetenciaTelaParaCompetenciaBD } from "../utils/dataUtils";

export function setModoTela(modo, registro = {}) {
    return {
        type: "DOCUMENTO_MODO_TELA",
        payload: {
            modo: modo,
            registro: registro,
        },
    };
}

export function setAguardando(aguardando) {
    return {
        type: "DOCUMENTO_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export function initForm(registro = {}) {
    return [initialize("documentoForm", registro)];
}

export function setFiltro(filtro) {
    return {
        type: "DOCUMENTO_FILTRO",
        payload: filtro,
    };
}

export function getLista() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : getState().documento.filtro.id_cliente;
            const idUC = getState().documento.filtro.id_unidade_consumidora;
            const idDocumentoTipo = getState().documento.filtro.id_documento_tipo;

            const resp = await axios.get(
                `${consts.API_URL}/documento?id_cliente=${idCliente}&id_unidade_consumidora=${idUC}&id_documento_tipo=${idDocumentoTipo}&id_empresa=${idEmpresa}`
            );
            dispatch({
                type: "DOCUMENTO_LISTADO",
                payload: resp,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
        try {
            if (!registro.id) {
                dispatch(setAguardando(true));

                axios.post(`${consts.API_URL}/documento`, {
                    ...registro,
                    vigencia_inicio: transformarCompetenciaTelaParaCompetenciaBD(registro.vigencia_inicio),
                    vigencia_fim: transformarCompetenciaTelaParaCompetenciaBD(registro.vigencia_fim),
                    id_usuario_inclusao: getState().auth.usuario.id,
                    id_usuario_alteracao: getState().auth.usuario.id,
                });
            } else {
                if (!window.confirm("Deseja realmente alterar?")) return {};
                
                dispatch(setAguardando(true));

                axios.put(`${consts.API_URL}/documento`, {
                    ...registro,
                    vigencia_inicio: transformarCompetenciaTelaParaCompetenciaBD(registro.vigencia_inicio),
                    vigencia_fim: transformarCompetenciaTelaParaCompetenciaBD(registro.vigencia_fim),
                    id_usuario_alteracao: getState().auth.usuario.id,
                });
            }

            setSuccess("Operação Realizada com sucesso.");
            dispatch(getLista());
            dispatch(setModoTela("lista"));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        confirmDialog("Deseja realmente excluir?", () => {
            axios
                .delete(`${consts.API_URL}/documento?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getLista());
                    dispatch(setModoTela("lista"));
                })
                .catch((e) => {
                    setErroAPI(e);
                });
        });
    };
}

export function getAnexoDocumento({ anexo, download = false } = {}) {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;

        if (!usuarioLogado || !anexo) {
            setError("Solicitação inválida");
            return {};
        }

        const respostaToken = await axios.get(`${consts.API_URL}/token`);
        const token = respostaToken.data;
        const url = `${consts.FILE_URL}/anexo?nome_arquivo=${encodeURIComponent(anexo)}&download=${download}&token=${token}`;

        if (download) {
            // ✅ download direto, compatível com iPhone/Safari
            window.location.href = url;
        } else {
            // ✅ abre em nova aba
            window.open(url, "_blank");
        }
    };
}

export function getListaCliente() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/cliente/listarSelect?id_empresa=${idEmpresa}`);
            dispatch({
                type: "DOCUMENTO_CLIENTE_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaUnidadeConsumidora() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/unidadeConsumidora/listarSelect?id_empresa=${idEmpresa}`);
            dispatch({
                type: "DOCUMENTO_UNIDADE_CONSUMIDORA_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function getListaDocumentoTipo() {
    const request = axios.get(`${consts.API_URL}/documentoTipo/listarSelect?id_segmento=2`); //id_segmento 2 é de cliente
    return {
        type: "DOCUMENTO_TIPO_SELECT_LISTADO",
        payload: request,
    };
}
